import type { JsonApiResponse } from '~/interfaces/api/main';
import type { BankAccountStatementStatus } from '~/interfaces/opportunities/bankAccounts/statements/statuses/main';
import { useAuthFetch } from '~/composables/useAuthFetch';

export interface OpportunityStatementsStatusesResult {
  items: BankAccountStatementStatus[];
  alert: string | null;
  raw: JsonApiResponse<BankAccountStatementStatus[]>;
}

export const EMPTY_STATEMENTS_STATUSES_RESULT: OpportunityStatementsStatusesResult = {
  items: [],
  alert: null,
  raw: {
    data: [],
    meta: {},
  },
};

export const getOpportunityStatementsStatuses = async (
  opportunityHashId: string,
  params: string | null = null,
): Promise<OpportunityStatementsStatusesResult> => {
  if (!opportunityHashId) {
    return EMPTY_STATEMENTS_STATUSES_RESULT;
  }
  const urlParams = params ? (params.startsWith('?') ? params : `?${params}`) : '';
  const response = await useAuthFetch(`opportunities/${opportunityHashId}/bank-account-statements/status${urlParams}`);
  const payload = (response?.data?.value ?? {}) as JsonApiResponse<BankAccountStatementStatus[]> & { meta?: { alert?: string | null } };

  return {
    items: payload.data ?? [],
    alert: payload.meta?.alert ?? null,
    raw: payload,
  };
};
